import { Outlet } from "react-router-dom";
import Banner from "./Banner";
import Footer from "./Footer";

function Layout({ onLogout }) {
  return (
    <div className="min-h-screen flex flex-col">
      <Banner onLogout={onLogout} />
      <main className="flex-grow">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

export default Layout;
